import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    mediaList: host + 'media/list',//获取媒体列表
    delMediaById: host + 'media/delMediaDataById',//删除某一个媒体
    synchronization:host + 'media/syncAllStory',//同步所有稿件
    syncsite:host+'media/syncSites',//同步网站
    viewcolumntree:host+'media/reloadColumn',//同步网站
    checkmedia:host+'/media/checkMedia',//点击下一步
    addmedia:host+'/media/add',//添加媒体
    syncStory:host+'/media/syncStory',//同步某一个稿件
    columnInformation:host+'/media/loadColumnByMediaCode',//同步某一个稿件
    authentication: host+'media/gotoOAuth',//获取认证链接
    isOAuthSuccess:host+'media/isOAuthSuccess',//判断是否认证成功
    save:host+'media/save'
};

export const getMediaList = (body, callBack) => {  //获取媒体管理的列表
    request({url:Apis.mediaList, body, callBack});
}
export const delMediaById = (body, callBack) => {  //删除
    request({url:Apis.delMediaById,contentType:"json", body, method:"post", callBack});
}
export const synchronization = (callBack) => {  //同步所有稿件
    request({url:Apis.synchronization, method:"post", callBack});
}
export const syncsite = (body,callBack) => {  //同步网站
    request({url:Apis.syncsite, method:"post", body, callBack});
}
export const viewcolumntree = (body,callBack) => {  //更新栏目树
    request({url:Apis.viewcolumntree,contentType:"json", method:"post", body, callBack});
}
export const checkmedia = (body,callBack) => {  //添加媒体
    request({url:Apis.checkmedia,contentType:"json", method:"post", body, callBack});
}
export const addmedia = (body,callBack) => {  //添加媒体
    request({url:Apis.addmedia,contentType:"json", method:"post", body, callBack});
}
export const syncStory = (body,callBack) => {  //添加媒体
    request({url:Apis.syncStory, body, callBack});
}
export const columnInformation = (body,callBack, errorCallBack) => {  //添加媒体
    request({url:Apis.columnInformation,contentType:"json", method:"post", body, callBack, message:{info:errorCallBack, error:errorCallBack}});
}
export const authentication = (body,callBack) => {  //添加媒体
    request({url:Apis.authentication, method:"post", body, callBack});
}
export const isOAuthSuccess = (body,callBack) => {  //添加媒体
    request({url:Apis.isOAuthSuccess, method:"post", body, callBack});
}
export const save = (body,callBack) => {  //添加媒体
    request({url:Apis.save,contentType:"json", method:"post", body, callBack});
}